// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-field .period-select {
  width: 100px;
}

.schedule-field .minutes-select {
  min-width: 120px;
}

.schedule-field .hours-select {
  min-width: 105px;
}

.schedule-field .days-of-week-select {
  min-width: 190px;
}

.schedule-field .days-select {
  min-width: 200px;
}

.schedule-field .months-select {
  min-width: 135px;
}

.schedule-field .react-select__multi-value {
  background: none !important;
  border: 1px solid #3c8dbc !important;
}

.schedule-field .react-select__multi-value__label {
  text-align: center;
  min-width: 20px;
  color: var(--text-color) !important;
  padding: 1px 1px 1px 4px !important;
}

.schedule-field__menu-help {
  border-top: 1px solid #d9d9d9;
}

.schedule-field__group {
  margin-right: var(--base-sizes-2);
  margin-bottom: var(--base-sizes-2);
  flex-wrap: nowrap;
  align-items: center;
  display: flex;
}

.schedule-field__word {
  margin-right: var(--base-sizes-2);
}

.schedule-field__minute-input {
  width: auto !important;
}

.schedule-field__end-space {
  margin-right: 7px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/ScheduleField/ScheduleField.css","webpack://./services/frontend/app/containers/ScheduleField/ScheduleField.css"],"names":[],"mappings":"AADA;ECEE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":[".schedule-field .period-select {\n    width: 100px;\n  }\n  .schedule-field .minutes-select {\n    min-width: 120px;\n  }\n  .schedule-field .hours-select {\n    min-width: 105px;\n  }\n  .schedule-field .days-of-week-select {\n    min-width: 190px;\n  }\n  .schedule-field .days-select {\n    min-width: 200px;\n  }\n  .schedule-field .months-select {\n    min-width: 135px;\n  }\n  .schedule-field .react-select__multi-value {\n    background: none !important;\n    border: 1px solid #3c8dbc !important;\n  }\n  .schedule-field .react-select__multi-value__label {\n    color: var(--text-color) !important;\n    min-width: 20px;\n    text-align: center;\n    padding: 1px 1px 1px 4px !important;\n  }\n\n.schedule-field__menu-help {\n  border-top: 1px solid #d9d9d9;\n}\n\n.schedule-field__group {\n    margin-right: var(--base-sizes-2);\n    margin-bottom: var(--base-sizes-2);\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n}\n\n.schedule-field__word {\n    margin-right: var(--base-sizes-2);\n}\n\n.schedule-field__minute-input {\n  width: auto !important;\n}\n\n.schedule-field__end-space {\n  display: inline-block;\n  margin-right: 7px;\n}\n",".schedule-field .period-select {\n  width: 100px;\n}\n\n.schedule-field .minutes-select {\n  min-width: 120px;\n}\n\n.schedule-field .hours-select {\n  min-width: 105px;\n}\n\n.schedule-field .days-of-week-select {\n  min-width: 190px;\n}\n\n.schedule-field .days-select {\n  min-width: 200px;\n}\n\n.schedule-field .months-select {\n  min-width: 135px;\n}\n\n.schedule-field .react-select__multi-value {\n  background: none !important;\n  border: 1px solid #3c8dbc !important;\n}\n\n.schedule-field .react-select__multi-value__label {\n  text-align: center;\n  min-width: 20px;\n  color: var(--text-color) !important;\n  padding: 1px 1px 1px 4px !important;\n}\n\n.schedule-field__menu-help {\n  border-top: 1px solid #d9d9d9;\n}\n\n.schedule-field__group {\n  margin-right: var(--base-sizes-2);\n  margin-bottom: var(--base-sizes-2);\n  flex-wrap: nowrap;\n  align-items: center;\n  display: flex;\n}\n\n.schedule-field__word {\n  margin-right: var(--base-sizes-2);\n}\n\n.schedule-field__minute-input {\n  width: auto !important;\n}\n\n.schedule-field__end-space {\n  margin-right: 7px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
